import { COUNTRY_CODE, INPUT_TYPE } from "../../constants/Constant";
import { AccountTypes, PaymentMethods } from "../add-employee/steps/Employee";

export const initialContractorDetailsFormField = [
      {
        columnCode: "title",
        editable: false,
        hidden: false,
        id: "title",
        index: 0,
        name: "Title",
        options: null,
        required: false,
        type: "text",
        uiVisible: true,
        width: 50,
        direction: "VERTICAL",
        readOnly: false,
        value: ""
      },
      {
        columnCode: "firstName",
        autoFocus: true,
        editable: false,
        hidden: false,
        id: "firstName",
        index: 0,
        name: "First Name",
        options: null,
        required: true,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 50,
        direction: "VERTICAL",
        readOnly: false,
        value: "",
        hasError:false,
        errMsg:"First Name is required"
      },
      {
        columnCode: "middleName",
        editable: true,
        hidden: false,
        id: "middleName",
        index: 1,
        name: "Middle Name",
        options: null,
        required: false,
        systemField: true,
        type: "email",
        uiVisible: true,
        width: 50,
        direction: "VERTICAL",
        readOnly: false,
        hasError:false,
        errMsg:"Middle Name is required"
      },
      {
        columnCode: "lastName",
        editable: true,
        hidden: false,
        id: "lastName",
        index: 2,
        name: "Last Name",
        options: null,
        required: true,
        systemField: true,
        type: "phone",
        uiVisible: true,
        width: 50,
        direction: "VERTICAL",
        readOnly: false,
        hasError:false,
        errMsg:"Last Name is required"
      },{
        columnCode: "displayName",
        editable: true,
        hidden: false,
        id: "displayName",
        index: 3,
        name: "Display Name",
        options: null,
        required: true,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 50,
        direction: "VERTICAL",
        readOnly: false,
        hasError:false,
        errMsg:"Display Name is required"
      },
      {
        columnCode: "socialSecurityNumber",
        editable: true,
        hidden: false,
        id: "socialSecurityNumber",
        index: 4,
        name: "Social Security Number",
        options: null,
        required: true,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 50,
        direction: "VERTICAL",
        readOnly: false,
        hasError:false,
        errMsg:"Social Security Number is required"
      },
      {
        columnCode: "employerIdentificationNumber",
        editable: true,
        hidden: false,
        id: "employerIdentificationNumber",
        index: 5,
        name: "Employer Identification Number",
        options: null,
        required: true,
        systemField: true,
        type: "text",
        uiVisible: false,
        width: 50,
        direction: "VERTICAL",
        readOnly: false,
        hasError:false,
        errMsg:"Employer Identification Number is required"
      },
      {
        columnCode: "emailId",
        editable: true,
        hidden: false,
        id: "emailId",
        index: 6,
        name: "Email",
        options: null,
        required: true,
        systemField: true,
        type: "email",
        uiVisible: true,
        width: 50,
        direction: "VERTICAL",
        readOnly: false,
        hasError:false,
        errMsg:"Enter a valid Email"
      }
    ];

    export const initialCompensationFormField = [
        {
        columnCode: "compensation",
        editable: true,
        hidden: false,
        id: "compensation",
        index: 0,
        name: "Hourly Wages Amount",
        options: null,
        required: true,
        systemField: true,
        type: "number",
        uiVisible: true,
        width: 50,
        direction: "VERTICAL",
        readOnly: false,
        hasError:false,
        errMsg:"Hourly wages are required"
      }
    ];

    export const initialContractorPaymentDetails = [
        {
        columnCode: "paymentMethod",
        editable: true,
        hidden: false,
        id: "paymentMethod",
        index: 0,
        name: "Payment Method",
        options: PaymentMethods,
        required: true,
        systemField: true,
        type: INPUT_TYPE.DROPDOWN,
        uiVisible: true,
        width: 50,
        direction: "VERTICAL",
        readOnly: false,
        hasError:false,
        errMsg:"Payment Method is required",
        defaultOptions: PaymentMethods
      },{
        columnCode: "bank",
        editable: true,
        hidden: false,
        id: "bank",
        index: 1,
        name: "Bank",
        options: [],
        required: true,
        systemField: true,
        type: INPUT_TYPE.DROPDOWN,
        uiVisible: true,
        width: 50,
        direction: "VERTICAL",
        readOnly: false,
        hasError:false,
        errMsg:"Bank is required",
        defaultOptions: []
      },{
        columnCode: "accountType",
        editable: true,
        hidden: false,
        id: "accountType",
        index: 2,
        name: "Account Type",
        options: AccountTypes,
        required: true,
        systemField: true,
        type: INPUT_TYPE.DROPDOWN,
        uiVisible: true,
        width: 50,
        direction: "VERTICAL",
        readOnly: false,
        hasError:false,
        errMsg:"Account Type is required",
        defaultOptions: AccountTypes
      },{
        columnCode: "ifsc",
        editable: true,
        hidden: false,
        id: "ifsc",
        index: 3,
        name: "IFSC Code",
        options: null,
        required: true,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 50,
        direction: "VERTICAL",
        readOnly: false,
        errMsg:"IFSC Code is required"
      },{
        columnCode: "routingNumber",
        editable: true,
        hidden: false,
        id: "routingNumber",
        index: 4,
        name: "Swift Code/Routing",
        options: null,
        required: true,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 50,
        direction: "VERTICAL",
        readOnly: false,
        errMsg:"Swift Code/Routing is required"
      },{
        columnCode: "accountNumber",
        editable: true,
        hidden: false,
        id: "accountNumber",
        index: 5,
        name: "Account Number",
        options: null,
        required: true,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 50,
        direction: "VERTICAL",
        readonly: false,
        hasError:false,
        errMsg:"Account Number is required"
      },{
        columnCode: "upiId",
        editable: true,
        hidden: false,
        id: "upiId",
        index: 6,
        name: "UPI ID",
        options: null,
        required: false,
        systemField: true,
        type: "text",
        uiVisible: false,
        width: 50,
        direction: "VERTICAL",
        readonly: false,
        hasError:false,
        errMsg:"Enter a valid UPI ID"
      }
    ]

    export const CONTRACTOR_FIELD_MAP = {
        ["DEFAULT"] : {detailsFields : ["title","firstName","middleName","lastName","displayName","emailId"], compensationFields : ["compensation"], paymentFields: ["paymentMethod","accountType","routingNumber","accountNumber"]},
        [COUNTRY_CODE.US] : {detailsFields : ["title","firstName","middleName","lastName","displayName","socialSecurityNumber","employerIdentificationNumber","emailId"], compensationFields : ["compensation"], paymentFields: ["paymentMethod","accountType","routingNumber","accountNumber"]},
        [COUNTRY_CODE.INDIA] : {detailsFields : ["title","firstName","middleName","lastName","displayName","emailId"], compensationFields : ["compensation"], paymentFields: ["paymentMethod","accountType","routingNumber","accountNumber", "upiId", "ifsc" ]},
        [COUNTRY_CODE.SINGAPORE] : {detailsFields : ["title","firstName","middleName","lastName","displayName","emailId"], compensationFields : ["compensation"], paymentFields: ["paymentMethod","bank","routingNumber","accountNumber"]},
        [COUNTRY_CODE.MY] : {detailsFields : ["title","firstName","middleName","lastName","displayName","emailId"], compensationFields : ["compensation"], paymentFields: ["paymentMethod","bank","routingNumber","accountNumber"]}
    }

    export  const contractorDetailDefaultValues = {
        "contractorType":"INDIVIDUAL",
        "compensationPeriod":"hourly",
    }